export const removeKycSession = () => sessionStorage.removeItem('kycSurvey');
